module.exports = "/assets/data/010363ae512900e0e0af2ddb79f80bc1-B6.data.json";